<template>
    <Card class="w-full max-w-md mx-auto text-center p-6 shadow-lg gap-0">

    <CardHeader class="flex flex-col items-center p-0 mb-5">
      <CardTitle class="text-[16px] font-semibold text-[#64748B]">
        {{ $t(`auth.${setPasswordType}.set-password-successful.title`) }}
      </CardTitle>
    </CardHeader>

    <CardContent class="pb-6">
      <span
          class="text-sm font-medium text-center text-gray-700 mb-8"
          v-html="$t(`auth.${setPasswordType}.set-password-successful.text`)"
      ></span>
    </CardContent>

    <CardFooter class="p-0 flex justify-center">
      <Button
          class="w-full bg-[#64748B] transition-colors hover:bg-[#64748B] hover:opacity-75"
          @click="toLoginPage"
      >
        {{ $t(`auth.${setPasswordType}.set-password-successful.actions.enter`) }}
      </Button>
    </CardFooter>
  </Card>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  CardFooter,
} from '@/components/ui/card'
import { Button } from "@/components/ui/button"

const router = useRouter();
const route = useRoute();

// --- Computed ---
const setPasswordType = computed(() => {
  return route.meta.setPasswordType || 'forgot-password'
})

// --- Methods ---
const toLoginPage = () => {
  router.push({ name: 'login' });
}
</script>

<style scoped>
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
</style>
